import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlybushireindaund() {



  const cardData =
  {
    keyword: 'Monthly Bus Hire in Daund',
    heading: 'Sanavi Travels: Monthly Bus Hire in Daund',
    headingDescription: 'Sanavi Travels offers reliable Monthly Bus Hire in Daund, providing safe, comfortable, and cost-effective transportation for corporate teams, schools, colleges, factories, and organizations requiring long-term travel solutions. Our fleet of well-maintained AC and non-AC buses, mini buses, and coaches ensures spacious seating, smooth rides, and ample luggage space for daily or extended trips. With professional drivers, flexible monthly hire packages, transparent pricing, and 24/7 support, Sanavi Travels guarantees punctual, dependable, and hassle-free service. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for daily commutes, employee transport, group travel, and long-distance trips. Choose Sanavi Travels for trusted monthly bus hire services in Daund, delivering comfort, safety, and seamless transportation for every organizational need.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird watchers, especially during the migratory season. Visitors can spot flamingos, pelicans, storks, and other waterbirds. Early morning boat rides offer the best viewing experience."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam, situated close to Daund, provide a peaceful setting for picnics, photography, and birdwatching. The expansive water body and surrounding greenery make it an ideal spot for relaxation."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is a significant religious site in Daund, dedicated to Lord Shiva. Devotees visit throughout the year for rituals, prayers, and festivals, enjoying the temple's serene spiritual atmosphere."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is an important transport hub connecting Pune, Solapur, and southern India. The junction facilitates travel and trade, making it vital to the region’s connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands near Bhigwan, close to Daund, are home to diverse bird species and rich biodiversity. Nature enthusiasts and photographers often explore this area for its wildlife and scenic landscapes."
  },
  {
    "title": "Local Sugarcane Fields",
    "description": "Daund is surrounded by fertile agricultural lands, particularly sugarcane plantations. Visitors can witness traditional farming practices and the rural lifestyle of Maharashtra."
  },
  {
    "title": "Village Temples and Wadis",
    "description": "The villages around Daund have several small temples and wadi shrines reflecting traditional religious practices. These sites are often centers for local festivals and community gatherings."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The scenic countryside along Indapur Road features farmland, canals, and open fields. It is ideal for relaxed drives, photography, and experiencing rural Maharashtra."
  },
  {
    "title": "Weekly Local Markets",
    "description": "Daund’s weekly markets are lively spaces where locals sell fresh produce, grains, livestock, and handicrafts. Visitors can experience the vibrancy of rural commerce and community life."
  },
  {
    "title": "Pilgrimage Transit Point",
    "description": "Daund is strategically located near religious destinations like Pandharpur and Bhigwan, making it a convenient stop for pilgrims traveling to temples and spiritual sites."
  }
]
,



"services": [
    {
      "name": "Monthly Bus Hire in Daund",
      "description": "Monthly Bus Hire in Daund offers flexible and cost-effective long-term bus rental solutions for individuals, families, schools, factories, and corporate offices. Whether for employee transport, school commuting, or regular group travel, our monthly bus hire ensures well-maintained buses, professional drivers, and a reliable schedule, making daily or periodic travel stress-free and convenient."
    },
    {
      "name": "Monthly Bus Rental Daund",
      "description": "Monthly Bus Rental in Daund provides affordable and efficient transportation solutions for long-term needs. Ideal for businesses, schools, and industrial units, this service ensures comfortable buses, punctual service, and professional chauffeurs. We customize schedules, routes, and amenities according to client requirements, ensuring a seamless travel experience for every passenger."
    },
    {
      "name": "Employee Transport Bus Daund",
      "description": "Employee Transport Bus in Daund offers corporate and industrial commuting solutions for staff members. With safe, reliable, and comfortable buses, we provide daily transport for employees to offices, factories, and IT parks. Our professional drivers, fixed schedules, and well-maintained buses make commuting efficient, secure, and convenient for companies and their employees."
    },
    {
      "name": "Staff Bus Service Daund",
      "description": "Staff Bus Service in Daund provides dedicated transportation for employees of factories, corporate offices, and industrial units. Designed to ensure timely and safe commuting, our service offers spacious seating, AC and non-AC options, and experienced drivers. Flexible monthly plans and affordable pricing make this service ideal for organizations of all sizes."
    },
    {
      "name": "Corporate Monthly Bus Daund",
      "description": "Corporate Monthly Bus in Daund specializes in providing long-term transportation solutions for offices, IT companies, and industrial establishments. We offer comfortable buses, professional chauffeurs, and flexible schedules for employee commuting, corporate events, and staff transfers. This service ensures reliability, punctuality, and cost-effectiveness for corporate clients."
    },
    {
      "name": "Factory Staff Bus Daund",
      "description": "Factory Staff Bus in Daund ensures safe and reliable transport for factory employees. With regular monthly routes, well-maintained buses, and experienced drivers, we provide hassle-free commuting for staff. Our service emphasizes comfort, punctuality, and affordability, making it an ideal choice for industrial units looking for long-term bus rental solutions."
    },
    {
      "name": "Affordable Monthly Bus Daund",
      "description": "Affordable Monthly Bus service in Daund offers budget-friendly long-term bus rental solutions without compromising on quality, safety, or comfort. Perfect for companies, schools, or group travel, our service provides well-maintained buses, professional drivers, and customizable routes at competitive rates, ensuring reliable and cost-effective monthly transportation."
    },
    {
      "name": "Chauffeur Driven Bus Daund",
      "description": "Chauffeur Driven Bus in Daund provides a hassle-free monthly bus rental experience with professional drivers handling navigation, traffic, and schedules. Ideal for employee transport, corporate commuting, and school buses, this service prioritizes safety, comfort, and punctuality, allowing passengers to enjoy stress-free travel every day."
    },
    {
      "name": "Best Monthly Bus Service Daund",
      "description": "Best Monthly Bus Service in Daund guarantees premium-quality buses, professional chauffeurs, and reliable long-term transportation solutions. Catering to corporate offices, industrial units, schools, and family groups, our service ensures consistent, comfortable, and punctual travel throughout the month, combining efficiency and convenience for all passengers."
    },
    {
      "name": "School Monthly Bus Daund",
      "description": "School Monthly Bus in Daund provides dedicated transportation for students with safe, reliable, and comfortable buses. With professional drivers, well-planned routes, and regular maintenance, our service ensures timely pickups and drops for school children. Monthly plans are flexible and affordable, making it ideal for parents and educational institutions."
    },
    {
      "name": "Industrial Bus Service Daund",
      "description": "Industrial Bus Service in Daund offers long-term commuting solutions for factories, warehouses, and industrial units. Our buses are equipped for comfort and safety, and professional drivers ensure punctual and reliable service. Flexible monthly rental packages are designed to meet the specific transportation needs of industrial staff and employees."
    },
    {
      "name": "Long Term Bus Hire Daund",
      "description": "Long Term Bus Hire in Daund provides flexible monthly rental solutions for corporate, educational, and industrial transportation needs. With well-maintained buses, experienced chauffeurs, and customizable itineraries, we ensure safe, comfortable, and efficient travel over extended periods. This service is ideal for businesses, schools, and large groups requiring regular transportation."
    },
    {
      "name": "Company Bus Contract Daund",
      "description": "Company Bus Contract in Daund provides reliable long-term transportation for corporate offices, IT companies, and factories. Our buses, professional drivers, and flexible scheduling ensure employees commute safely and comfortably. Customizable contracts and monthly rental plans make it convenient and cost-effective for businesses to manage staff transportation efficiently."
    },
    {
      "name": "Daund Transport Service",
      "description": "Daund Transport Service offers comprehensive monthly bus rental solutions for corporate, school, industrial, and family travel. With a fleet of well-maintained buses, professional chauffeurs, and customizable plans, our service prioritizes safety, comfort, and convenience. We cater to both short and long-distance travel needs, ensuring reliable and efficient transportation year-round."
    },
    {
      "name": "Monthly Bus Booking Daund",
      "description": "Monthly Bus Booking in Daund allows customers to reserve buses for extended periods through an easy and convenient process. With instant confirmation, multiple bus options, and flexible schedules, this service simplifies planning for corporate commutes, school transportation, and group travel. Our focus on comfort, reliability, and affordability ensures hassle-free long-term bus rental."
    }
  ],
  "tableData": [
    ["Monthly Bus Hire in Daund", "Monthly Bus Rental Daund"],
    ["Employee Transport Bus Daund", "Staff Bus Service Daund"],
    ["Corporate Monthly Bus Daund", "Factory Staff Bus Daund"],
    ["Affordable Monthly Bus Daund", "Chauffeur Driven Bus Daund"],
    ["Best Monthly Bus Service Daund", "School Monthly Bus Daund"],
    ["Industrial Bus Service Daund", "Long Term Bus Hire Daund"],
    ["Company Bus Contract Daund", "Daund Transport Service"],
    ["Monthly Bus Booking Daund", "—"]
  ]
,



"whychoose": [
  {
    "WhyChooseheading": "Monthly Bus Hire in Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers convenient and reliable monthly bus hire services in Daund, ideal for corporate transport, school commutes, long-term events, and regular group travel."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are air-conditioned, clean, and regularly serviced, ensuring a smooth and comfortable ride for long-term monthly travel in Daund."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are punctual, courteous, and familiar with Daund and surrounding routes, ensuring safe and timely transportation for your monthly commute."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront monthly bus hire pricing, covering fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, schedule changes, and any travel queries for your monthly bus hire."
  },
  {
    "WhyChooseheading": "Flexible Monthly Packages",
    "WhyChoosedescription": "Choose from customized monthly bus hire plans that suit your schedule, group size, and travel requirements in Daund."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized regularly to ensure a safe and hygienic environment for passengers."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for monthly bus hire in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer monthly bus hire in Daund?',
    answer: 'Yes, Sanavi Travels provides flexible and reliable monthly bus hire services in Daund for corporate, school, and regular group travel.'
  },
  {
    question: 'How can I book a monthly bus in Daund?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for monthly hire?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20-seater, 32-seater, 35-seater, 45-seater, and 50-seater options for long-term use.'
  },
  {
    question: 'Are the buses well-maintained and air-conditioned?',
    answer: 'Yes, all buses are clean, air-conditioned, and regularly serviced to ensure comfortable monthly travel.'
  },
  {
    question: 'Are drivers experienced with Daund routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with local and intercity routes for reliable monthly transport.'
  },
  {
    question: 'Can I customize the monthly bus hire schedule?',
    answer: 'Absolutely. Sanavi Travels offers flexible monthly packages to match your schedule and travel requirements.'
  },
  {
    question: 'Are the buses sanitized regularly?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to maintain a safe environment for passengers.'
  },
  {
    question: 'What payment options are available for monthly bus hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the monthly hire period?',
    answer: 'Yes, our 24x7 customer support team is available throughout your monthly bus hire service in Daund.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    feedback: 'We hired a bus monthly for our office commute. Excellent service, punctual driver, and comfortable buses throughout.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshmukh',
    feedback: 'Sanavi Travels made our monthly bus hire seamless. Clean vehicles and reliable service made daily commuting stress-free.',
    rating: 5
  }
];

































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Bus Hire in Daund - Sanavi Travels",
  "description": "Sanavi Travels offers monthly bus hire in Daund, ideal for employee transport, staff buses, corporate travel, factory staff, and school transport. Affordable and chauffeur-driven buses available for long-term contracts with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "60"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Monthly Bus Hire in Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers monthly bus hire in Daund, ideal for employee transport, staff buses, corporate travel, factory staff, and school transport. Affordable and chauffeur-driven buses available for long-term contracts with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/120.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlybushireindaund;